import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useUserInteractionWithPcaChat } from '../helpers/useUserInteractionWithPcaChat';

type PcaChatModalState = 'tooltip' | 'welcome' | 'chat' | null;

interface PcaChatModalContext {
  pcaChatModalState: PcaChatModalState;
  setPcaChatModalState: (pcaModalState: PcaChatModalState) => void;
}

export const PcaChatModalContext = createContext<PcaChatModalContext | undefined>(undefined);

export const usePcaChatModalContext = (): PcaChatModalContext => {
  const context = useContext(PcaChatModalContext);
  if (context === undefined) {
    throw new Error('PcaChatModalContext must be used within a PcaChatModalContext.Provider');
  }
  return context;
};

export const PcaChatModalContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [pcaChatModalState, setPcaChatModalState] = useState<PcaChatModalState>(null);

  const { isInteracted } = useUserInteractionWithPcaChat();

  useEffect(() => {
    // Check if the user has dismissed or interacted with the tooltip before
    // If they haven't, show the chat tooltip
    if (!isInteracted) {
      setPcaChatModalState('tooltip');
    }
  }, [isInteracted]);
  return (
    <PcaChatModalContext.Provider value={{ pcaChatModalState, setPcaChatModalState }}>
      {children}
    </PcaChatModalContext.Provider>
  );
};
